import { FocusEvent } from "react";
import { useTranslation } from "react-i18next";

import { TextField } from "../../components/inputs/text-field/TextField";

import { FieldErrorsProps } from "../../components/inputs/_assets/input-wrapper/FieldErrors";
import { AdministrativeDivision2USSelect } from "./AdministrativeDivision2USSelect";

type AdministrativeDivision2SelectProps = {
  label: string;
  country?: string;
  administrativeDivision1?: string;
  administrativeDivision2?: string;
  testID: string;
  onChange?: (name: string) => void;
  errors?: FieldErrorsProps["children"];
  isInvalid?: boolean;
  onBlur?: (e: FocusEvent<Element>) => void;
  isDisabled?: boolean;
  description?: string;
  isRequired?: boolean;
  context?: string;
};

export function AdministrativeDivision2Select(
  props: AdministrativeDivision2SelectProps
) {
  const { t } = useTranslation();
  const {
    label,
    country,
    administrativeDivision2,
    onChange,
    testID = "administrative-division-2-select",
    isRequired = true,
  } = props;

  const isDropDown = props.context === "address-history" && country === "US";
  const isTextField = country === "US" || country === "GB";

  if (isDropDown) {
    const placeholder = `${t("Select")} ${label.split(" ")[0]?.toLowerCase()}`;
    return (
      <AdministrativeDivision2USSelect
        {...props}
        label={label}
        testID={`${testID}-county-select`}
        placeholder={placeholder}
        isRequired={isRequired}
      />
    );
  }

  if (isTextField) {
    return (
      <TextField
        {...props}
        onChange={(value: string) => {
          onChange?.(value);
        }}
        value={administrativeDivision2 ?? ""}
        testID={`${testID}-county-input`}
        isRequired={isRequired}
      />
    );
  }

  return <></>;
}
